import React from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
} from '@mui/material'
import ErrorMessage from '../../component/shared/component/ErrorMessage'
import { useGetWhatsappConfigs, usePostWhatsappConfig } from '../../api/whatsapp-config'
import Row from './Row'
import Form from './Form'
import { LoadingSkeletonRows } from '../shared/LoadingSkeletonRows'

const Table = ({ open, setOpen }) => {
  const { data = [], isLoading, error, refetch } = useGetWhatsappConfigs()

  return (
    <Box>
      {error ? (
        <ErrorMessage error={error} onRetry={refetch} />
      ) : data?.length > 0 || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell>Display Name</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={3} />
                ) : (
                  data.map((row) => <Row data={row} key={row.id} refetch={refetch} />)
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
        </>
      ) : (
        <ErrorMessage empty />
      )}
      <Form open={open} setOpen={setOpen} api={usePostWhatsappConfig} refetch={refetch} />
    </Box>
  )
}

export default Table
